var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmailServicesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_746_1324",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 95,
    height: 95
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.532227H94.5V94.5322H0.5V0.532227Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_746_1324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.5144 62.5491H55.1782C52.5795 69.8554 47.8615 73.5066 41.0252 73.5066C35.8974 73.5066 31.7611 71.5926 28.6237 67.7676C25.4834 63.9426 23.9124 58.6448 23.9124 51.8782C23.9124 43.1203 26.087 35.9956 30.4335 30.5059C34.7791 25.0162 40.0195 22.2732 46.1491 22.2732C51.6894 22.2732 55.1601 24.51 56.5717 28.9864H56.7961L57.3491 23.3085H69.8919C68.2196 39.6 67.3801 50.2527 67.3801 55.2611C67.3801 60.617 68.7917 63.2912 71.6177 63.2912C74.5927 63.2912 77.0463 61.2646 78.9745 57.2123C80.9066 53.159 81.877 47.8612 81.877 41.3219C81.877 32.373 79.1054 25.0381 73.5717 19.3202C68.0314 13.6032 60.3059 10.7437 50.3838 10.7437C39.7549 10.7437 30.9187 14.5583 23.8799 22.1902C16.8382 29.8182 13.3169 39.1253 13.3169 50.1009C13.3169 60.7326 16.4295 69.1104 22.6536 75.2295C28.8777 81.3486 37.4685 84.4095 48.4326 84.4095C56.7961 84.4095 64.449 82.7668 71.3971 79.4776V90.435C65.043 93.2219 56.8677 94.6182 46.873 94.6182C33.1583 94.6182 22.0023 90.5725 13.4 82.4851C4.79873 74.3967 0.5 63.5262 0.5 49.8697C0.5 35.9488 5.08811 24.2454 14.2691 14.7607C23.4425 5.27602 35.2604 0.532227 49.7143 0.532227C63.0919 0.532227 73.9156 4.21208 82.1845 11.5766C90.4534 18.9401 94.586 28.6425 94.586 40.6926C94.586 50.6004 92.0598 58.5436 87.0047 64.5328C81.9524 70.5182 75.6891 73.5104 68.2234 73.5104C64.5474 73.5104 61.5504 72.4971 59.2487 70.4704C56.9403 68.4409 55.6959 65.7992 55.5144 62.5491ZM48.1003 32.2575C44.7566 32.2575 42.0347 34.2182 39.9364 38.1378C37.8333 42.0602 36.7847 46.5977 36.7847 51.7617C36.7847 55.4349 37.501 58.2934 38.9298 60.342C40.3595 62.3906 42.2047 63.4106 44.4739 63.4106C47.9694 63.4106 50.7162 61.4823 52.7247 57.6172C54.7293 53.7559 55.7322 48.5919 55.7322 42.129C55.7322 39.068 55.033 36.6574 53.6406 34.8992C52.2471 33.1399 50.4048 32.2575 48.1003 32.2575Z",
    fill: "#395E90"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailServicesIcon);
export default __webpack_public_path__ + "static/media/gmail_services_icon.be408cc1a60f23b582ea08cefa0da500.svg";
export { ForwardRef as ReactComponent };